/**
 * Converts internal identifiers (snake_case, kebab-case) to human-readable labels.
 * e.g. "k8s_provision" → "K8s Provision", "kestrel-generate-k8s-manifest" → "Generate K8s Manifest"
 */
export function formatInternalName(name: string): string {
  if (!name) return '';

  // Strip common prefixes that aren't useful to show
  let cleaned = name
    .replace(/^kestrel-/, '')
    .replace(/^approval-wait-/, '')
    .replace(/^(github|gitlab|slack|confluence|jira|linear|pagerduty|datadog)-/, '');

  // Replace separators with spaces
  cleaned = cleaned.replace(/[-_]+/g, ' ');

  // Capitalize each word, with special casing for known abbreviations
  const ABBREVIATIONS: Record<string, string> = {
    'k8s': 'K8s',
    'pr': 'PR',
    'mr': 'MR',
    'rca': 'RCA',
    'aws': 'AWS',
    'iac': 'IaC',
    'cli': 'CLI',
    'oci': 'OCI',
    'rds': 'RDS',
    'msk': 'MSK',
    's3': 'S3',
    'ec2': 'EC2',
    'ecs': 'ECS',
    'eks': 'EKS',
    'vpc': 'VPC',
    'iam': 'IAM',
    'sqs': 'SQS',
    'sns': 'SNS',
    'hpa': 'HPA',
    'dns': 'DNS',
    'api': 'API',
    'url': 'URL',
    'dm': 'DM',
    'pd': 'PD',
    'ci': 'CI',
    'cd': 'CD',
    'argocd': 'ArgoCD',
    'fluxcd': 'Flux CD',
  };

  return cleaned
    .split(' ')
    .map(word => {
      const lower = word.toLowerCase();
      if (ABBREVIATIONS[lower]) return ABBREVIATIONS[lower];
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}
